import { ENGLISH } from './language-definitions';
import { LanguageConfig } from './model/language-config';

export const DEFAULT_LANGUAGE_CONFIG: LanguageConfig = {
  availableLangs: [ENGLISH],
  defaultLang: ENGLISH.id
};
